import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, FileText, Target, Zap, ShieldCheck, LifeBuoy } from 'lucide-react';
export function SolutionSection() {
  const deliverables = [{
    icon: <FileText className="w-6 h-6 text-brand-orange" data-id="element-170" />,
    title: 'El Manual Maestro',
    desc: 'El Ritual Anti-Procrastinación de 10 Minutos (PDF).'
  }, {
    icon: <Target className="w-6 h-6 text-brand-orange" data-id="element-171" />,
    title: 'El Framework 2-2-6',
    desc: 'El paso a paso para pasar de la parálisis a la acción en 10 minutos.'
  }, {
    icon: <Zap className="w-6 h-6 text-brand-orange" data-id="element-172" />,
    title: 'Los 3 Micro-Disparadores Físicos',
    desc: 'Cómo usar tu cuerpo para forzar al cerebro a enfocarse.'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-brand-orange" data-id="element-173" />,
    title: 'Sistema de Cero Fricción',
    desc: 'Técnicas para que empezar mañana sea un 80% más fácil.'
  }, {
    icon: <LifeBuoy className="w-6 h-6 text-brand-orange" data-id="element-174" />,
    title: 'Lista de Tareas de Emergencia',
    desc: 'Qué hacer cuando el día parece totalmente perdido.'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-175">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-orange/5 blur-[100px] rounded-full pointer-events-none" data-id="element-176" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-177">
        <FadeIn data-id="element-178">
          <div className="text-center mb-16" data-id="element-179">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-180">
              Presentamos el{' '}
              <span className="text-brand-orange" data-id="element-181">Método 2-2-6</span>
            </h2>
            <p className="text-xl text-brand-orange font-medium tracking-wide uppercase mb-8" data-id="element-182">
              (El Disparador de Inercia)
            </p>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-183">
              Un ritual técnico de exactamente 600 segundos diseñado para
              engañar a tu cerebro. No te pedimos una hora de trabajo; te
              pedimos 10 minutos de ejecución ciega divididos en fases
              sensoriales y físicas que rompen la parálisis química del cerebro
              y activan el flujo de dopamina por progreso real.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-184">
          <div className="bg-brand-card rounded-3xl p-8 md:p-12 border border-white/5 shadow-2xl" data-id="element-185">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-186">
              Lo que obtienes hoy:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-187">
              {deliverables.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/[0.02] transition-colors border border-transparent hover:border-white/5" data-id="element-188">
                  <div className="w-12 h-12 rounded-full bg-brand-orange/10 flex items-center justify-center flex-shrink-0 border border-brand-orange/20" data-id="element-189">
                    {item.icon}
                  </div>
                  <div data-id="element-190">
                    <h4 className="text-white font-bold text-lg mb-1" data-id="element-191">
                      {item.title}
                    </h4>
                    <p className="text-gray-400 leading-relaxed" data-id="element-192">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}